<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="starting-map">
    <PivotComponent
      v-model="internalPivotConfig"
      :data="contentData.data"
      :dimensions="contentData.dimensions"
      :data-card="dataCard" 
      mode="edit"
      component="map"
      :current-chart="{id:'map',enabled: true}"
      :default-pivot-config="defaultPivotConfig"
      :table-edit-open="mapEditOpen"
      @toggle-edit="toggleEdit"
      @reload-data-card="reloadDataCard"
    />
  </div>
</template>

<script>
import PivotComponent from '../table/PivotComponent.vue'

//import 'proj4leaflet'
//import proj4 from 'proj4'

// proj4.defs(
//   'EPSG:3857',
//   '+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs +type=crs'
// )

// const customCrs = new L.Proj.CRS(
//   'EPSG:25831',
//   '+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs',
//   {
//     resolutions: [4096, 2048, 1024, 512, 256, 128, 64, 32, 16, 8],
//     origin: [1021291.96, 6553629.65],
//     bounds: L.bounds([-1300111.74, 3804640.43], [855431.63, 9528699.59]),
//   }
// )

/**
 * Map view disposition
 * @example [none]
 */
export default {
  name: 'StartingMap',
  components: {
    PivotComponent,
    // LMap,
    // LTileLayer,
    // LGeoJson,
    // // LMarker,
    // // LPopup,
    // // LLayerGroup,
    // LImageOverlay,
    // LControlLayers,
    // LControlZoom,
    // //LControl,
    // SelectCompWrapper,
    // ColorPickerInput,
    // OpacityRangeInput,
    // CheckboxInput,
    // RadioScaleInput,
    // TimeSlider,
    // QuickFilter,
    // Loader,
    // GrowUpMenu,
  },
  model: {
    prop: 'pivotConfig',
    event: 'change',
  },
  props: {
    dataCard: {
      type: Object,
    },

    pivotConfig: {
      type: Object,
    },
    contentData: {
      type: Object,
    },
  },
  data() {
    return {
      defaultPivotConfig: null,
      mapEditOpen: false,
    }
  },
  computed: {
    internalPivotConfig: {
      get() {
        return this.pivotConfig
      },
      set(value) {
        this.$emit('change', value)
      },
    },
  },

  watch: {
    internalPivotConfig: {
      handler(value) {
        this.$emit('change', value)
      },
      deep: true,
    },
  },

  methods: {
    reloadDataCard() {
      this.$emit('reload-data-card')
    },
    toggleEdit() {
      this.mapEditOpen = !this.mapEditOpen
    },
  },
}
</script>

<style lang="stylus" scoped>
.top-filters
  display: flex
  justify-content: space-between
  align-items: center
  padding: vw(6px) vw(25px)
  width: 100%

  .mobile &
    flex-direction: column
    align-items: flex-start
    margin-bottom: vw(16px)

  .filters-left
    display: flex
    margin-bottom: vw(10px)
    gap: vw(10px)

    .quick-filters-wrapp
      display: flex
      gap: vw(10px)

    .filters-title
      margin-right: vw(15px)
      m-font-size(14, 16)

    .location-filter
      .title
        m-font-size(12, 16)
        margin-bottom: vw(5px)
        height: vw(16px)
        color: $grey

  .filters-buttons
    display: flex
    align-items: center
    gap: vw(10px)

    .mobile &
      width: 100%

    .legend-wrapper
      display: flex
      flex-direction: column
      margin-right: vw(10px)
      width: vw(300px)

      .mobile &
        margin-top: vw(10px)
        margin-right: 0
        width: 100%

      .colors-wrapper
        display: flex
        width: 100%
        gap: vw(10px)

        .color-wrapper
          position: relative
          display: flex
          flex: 1
          flex-direction: column

          .color-box
            height: vw(25px)

          .threshold
            position: absolute
            top: 100%
            m-font-size(14, 20)
            left: 100%
            color: $more-grays
            text-align: center
            // transform: translate(calc(-50% + vw(10px)),0);
            transform: translate(vw(-10px), 0)

      .color-wrapp
        width: 100%
        height: vw(25px)

      .labels-wrapper
        display: flex
        justify-content: space-between
        width: 100%

        span
          m-font-size(14, 20)
          color: $more-grays

.buttons-wrap
  display: flex
  align-items: center
  gap: vw(10px)

  .mobile &
    justify-content: right
    padding: vw(10px) vw(15px)
    width: 100%

  .icon
    cursor: pointer

    &.disabled
      m-icon("refresh-grey-fill", 32, $bcn-other-grey, false)
      cursor: not-allowed

    $colors = "black" "white" "grey"
    $icons = "edit" "refresh" "download" "share"

    for $color in $colors
      for $icon in $icons
        &.{$color}-fill
          &.{$icon}
            m-icon($icon + "-" + $color + "-fill", 32, $color, false)

            .mobile &
              m-icon($icon + "-" + $color + "-fill", 38, $color, false)

.hidden
  display: none

.edit-wrapp-options-mobile
  padding: vw(10px) vw(20px)

  .title
    m-font-size(14, 20)
    margin-bottom: vw(10px)
    font-weight: 600
</style>
